import { Component, OnInit, ViewChild } from '@angular/core';
import { InvoiceService } from '../../service/invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../shared/AppSettings';
import { ThrowStmt } from '@angular/compiler';

@Component({
    selector: 'app-lp-invoice-details',
    templateUrl: './lp-invoice-details.component.html',
    styleUrls: ['./lp-invoice-details.component.css']
})
export class LPInvoiceDetailsComponent implements OnInit {

  validationMessage: any;
  validationMessages: any[];
  msgs: Message[] = [];


  constructor(private invoiceService: InvoiceService, private route: ActivatedRoute, private router: Router) { 
    let x =  1;
  }

  ngOnInit() {
    this.validateLP();

    
  }

  validateLP()
  {
    //let invoiceId = this.route.snapshot.paramMap.get('invoice');
    let invoiceId = this.route.snapshot.queryParamMap.get('lpi');
    let invoiceFilterByInvoiceIdEncoded = {
      //InvoiceId: invoiceId,
      InvoiceIdLink: invoiceId    };
    this.invoiceService.validateInvoiceLP(invoiceFilterByInvoiceIdEncoded).subscribe((result: any) => {
      // this.invoiceDetails = result;
      window.location.href = result;

    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.showMessage('error', '', errMessage);
      });
  }




  
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/lp/lp-invoice-details/lp-invoice-details.component.ts